// extracted by mini-css-extract-plugin
module.exports = {"link":"editorial-link_link__cEiih","linkSmall":"editorial-link_linkSmall__k_cEr","linkMedium":"editorial-link_linkMedium__FJU99","smallIcon":"editorial-link_smallIcon__3yByc"};